import { render, staticRenderFns } from "./RegisterCheck.vue?vue&type=template&id=6190c6d6&scoped=true&"
import script from "./RegisterCheck.vue?vue&type=script&lang=js&"
export * from "./RegisterCheck.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCheck.vue?vue&type=style&index=0&id=6190c6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6190c6d6",
  null
  
)

export default component.exports